import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="bg-white min-h-screen font-sans text-[#7a7a7a]">
      
      {/* Header / Breadcrumb Section with #ffdfef color */}
      <div className="relative h-44 bg-[#ffdfef] flex flex-col items-center justify-center">
        <h1 className="text-2xl md:text-3xl font-bold text-black uppercase tracking-[0.2em]">
          Refund Policy
        </h1>
        <div className="text-[12px] mt-3 text-gray-600 uppercase tracking-widest">
          Home <span className="mx-2 text-gray-400">/</span> Refund Policy
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-16 md:py-24">
        <div className="space-y-12">
          
          {/* Section 1: Overview */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              1. Policy Overview
            </h2>
            <p className="text-[14.5px] leading-[1.8] text-justify">
              At <strong>Simple Kindness</strong>, we strive to ensure our community members are satisfied with our advocacy and resources. Since we primarily provide digital resources and personalized advocacy services, our refund policy is designed to be fair to both the provider and the recipient.
            </p>
          </section>

          {/* Section 2: Eligibility */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              2. Eligibility for Refund
            </h2>
            <p className="text-[14.5px] leading-[1.8] mb-4">
              Refunds may be considered under the following circumstances:
            </p>
            <ul className="space-y-3 pl-2">
              {[
                'Duplicate payments made due to technical errors.',
                'Services that were not initiated within the promised timeframe.',
                'Cancellations made within 24 hours of booking a personalized session.',
                'Technical issues that prevent access to paid digital resources.'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-[14px]">
                  <span className="mt-2 w-1.5 h-1.5 bg-[#ffdfef] border border-gray-300 rounded-full flex-shrink-0"></span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Section 3: Non-Refundable Items */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              3. Non-Refundable Services
            </h2>
            <p className="text-[14.5px] leading-[1.8] text-justify">
              Please note that completed advocacy sessions, personalized reports already delivered, and donations made towards mental health awareness events are generally non-refundable. We invest significant time and resources into each individual case once the work has commenced.
            </p>
          </section>

          {/* Section 4: Process */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              4. How to Request a Refund
            </h2>
            <p className="text-[14.5px] leading-[1.8] text-justify">
              To request a refund, please email us at <span className="text-black font-semibold">support@simplekindness.com</span> with your transaction details and the reason for your request. Our team will review your case and respond within 5-7 business days.
            </p>
          </section>

          {/* Highlighted Notice */}
          <div className="mt-16 p-8 bg-[#ffdfef]/20 border border-[#ffdfef] rounded-sm text-center">
            <p className="text-[14px] text-black font-medium">
              We value your support in our journey towards mental health awareness. 
              Our goal is always kindness and mutual understanding.
            </p>
          </div>
        </div>

        {/* Footer info */}
        <div className="mt-20 pt-8 border-t border-gray-100 text-[12px] text-gray-400 text-center uppercase tracking-widest">
          Simple Kindness | Refund & Cancellation
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;